import { render, staticRenderFns } from "./unauthorized.component.vue?vue&type=template&id=3c70c9a4&scoped=true"
import script from "./unauthorized.component.ts?vue&type=script&lang=ts&external"
export * from "./unauthorized.component.ts?vue&type=script&lang=ts&external"
import style0 from "./unauthorized.component.vue?vue&type=style&index=0&id=3c70c9a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c70c9a4",
  null
  
)

export default component.exports